<!-- ======= Contact Us Section ======= -->
<section id="contact" class="contact animated fadeIn">
  <div class="container">

    <div class="section-title" data-aos="fade-up">
      <h2>Contacto</h2>
      <p>Contáctanos para empezar</p>
    </div>

    <div class="row">

      <div class="col-lg-10 d-flex align-items-stretch ml-auto mr-auto" data-aos="fade-up" data-aos-delay="100">
        <div class="info ">

          <div class="email">
            <i class="icofont-envelope"></i>
            <h4>Email:</h4>
            <p>donemilioconstrucciones@gmail.com</p>
          </div>

          <div class="phone">
            <i class="icofont-phone"></i>
            <h4>Teléfonos:</h4>
            <p>(+ 549 264 541 5848) / (+34 656 90 43 26)</p>
          </div>

          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3399.3131716163925!2d-68.55918103547849!3d-31.570458849812887!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x96814070b75d7d0d%3A0x5e416a35311e7aa3!2sCalle%20Vidart%20S%204975%2C%20Villa%20Krause%2C%20San%20Juan!5e0!3m2!1ses-419!2sar!4v1582838903851!5m2!1ses-419!2sar" frameborder="0" style="border:0; width: 100%; height: 290px;" allowfullscreen></iframe>
        </div>

      </div>

      <!-- <div class="col-lg-7 mt-5 mt-lg-0 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="200">
        <form action="forms/contact.php" method="post" role="form" class="php-email-form">
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="name">Nombre</label>
              <input type="text" name="name" class="form-control" id="name" data-rule="minlen:4" data-msg="Please enter at least 4 chars" />
              <div class="validate"></div>
            </div>
            <div class="form-group col-md-6">
              <label for="name">Email</label>
              <input type="email" class="form-control" name="email" id="email" data-rule="email" data-msg="Please enter a valid email" />
              <div class="validate"></div>
            </div>
          </div>
          <div class="form-group">
            <label for="name">Asunto</label>
            <input type="text" class="form-control" name="subject" id="subject" data-rule="minlen:4" data-msg="Please enter at least 8 chars of subject" />
            <div class="validate"></div>
          </div>
          <div class="form-group">
            <label for="name">Mensaje</label>
            <textarea  id="text-area" class="form-control" name="message" rows="10" data-rule="required" data-msg="Please write something for us"></textarea>
            <div class="validate"></div>
          </div>
          <div class="mb-3">
            <div class="loading">Cargando...</div>
            <div class="error-message"></div>
            <div class="sent-message">Tu mensaje ha sido enviado. Gracias!</div>
          </div>
          <div class="text-center"><button type="submit" onclick="sendEmail()">Enviar mensaje</button></div>
        </form>
      </div> -->

    </div>

  </div>
</section>
